const prefixes = {
  courses: 'crs',
  startedCourses: 'scrs',
  testBank: 'tst',
  testAttempts: 'tat',
  events: 'evt',
  blogs: 'blg',
  additionalPages: 'adp',
  team: 'mem',
  courseApplications: 'cap',
  eventApplications: 'eap',
  courseCategories: 'cat-course',
  eventCategories: 'cat-event',
  blogCategories: 'cat-blog'
}

let lastTimestamp = 0
let sameTimestampIndex = 0

export function getEntityPrefix(type) {
  return prefixes[type] || type || 'item'
}

export function createEntityId(type) {
  const timestamp = Date.now()
  const suffix = timestamp === lastTimestamp ? `-${++sameTimestampIndex}` : ''
  lastTimestamp = timestamp
  if (!suffix) sameTimestampIndex = 0
  return `${getEntityPrefix(type)}-${timestamp}${suffix}`
}

export function createNestedId(parentId, groupKey) {
  return createEntityId(`${parentId}-${groupKey}`)
}
